interface RedirectButtonProps {
  name: string;
  onClick: () => void;
}

export default function RedirectButton({ onClick, name }: RedirectButtonProps) {
  return (
    <p
      style={{
        marginTop: 24,
        cursor: 'pointer',
        color: 'var(--Text-colors-Text-Secondary)',
        fontFamily: 'Poppins',
        fontSize: 13,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal'
      }}
      onClick={onClick}
    >
      {name}
    </p>
  );
}
